var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIgSavelarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.57 5.86a4.62 4.62 0 0 1 4.61-4.61h9.64c2.55 0 4.6 2.08 4.62 4.6v14.1c0 1.07-.39 2.01-1.21 2.5-.83.49-1.84.37-2.77-.15l-4.9-2.72a1.2 1.2 0 0 0-.55-.12c-.25 0-.45.06-.57.13l-4.89 2.7c-.93.52-1.95.64-2.77.15-.82-.48-1.21-1.42-1.21-2.49V5.86Zm4.61-3.11a3.12 3.12 0 0 0-3.11 3.11v14.09c0 .73.26 1.07.47 1.2.22.13.64.19 1.29-.17l4.87-2.7c.4-.23.88-.32 1.3-.32.44 0 .91.1 1.3.32l4.88 2.7c.65.36 1.07.3 1.29.18.21-.13.47-.47.47-1.21V5.86c0-1.7-1.4-3.11-3.12-3.11H7.18Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIgSavelarge);
export default __webpack_public_path__ + "static/media/igSave.large.92f39061e9603ee72f91cdf4d2275919.svg";
export { ForwardRef as ReactComponent };